import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Onboarding = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Welcome to Dr. Vivara',
      subtitle: 'Your trusted healthcare partner',
      description: 'Connect with certified doctors, access medicines, and improve your health from anywhere.',
      image: process.env.PUBLIC_URL + '/assets/onboarding/1.png'
    },
    {
      title: 'Expert Consultations',
      subtitle: 'Professional medical advice',
      description: 'Get audio and video consultations with verified doctors at affordable prices.',
      image: process.env.PUBLIC_URL + '/assets/onboarding/2.png'
    },
    {
      title: 'Medicine Delivery',
      subtitle: 'Prescription medicines at your doorstep',
      description: 'Order medicines from verified retailers with fast and reliable delivery.',
      image: process.env.PUBLIC_URL + '/assets/onboarding/3.png'
    },
    {
      title: 'Wellness Programs',
      subtitle: 'Holistic health approach',
      description: 'Access yoga sessions, health podcasts, and nutrition guidance for complete wellness.',
      image: process.env.PUBLIC_URL + '/assets/onboarding/4.png'
    },
    {
      title: 'Privacy & Security',
      subtitle: 'Your data is our priority',
      description: 'We adhere to the highest standards of data protection. By proceeding, you agree to our Privacy Policy and Terms and Conditions.',
      image: process.env.PUBLIC_URL + '/logo.png'
    }
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      localStorage.setItem('onboarding_completed', 'true');
      navigate('/role-selection');
    }
  };

  const handleSkip = () => {
    localStorage.setItem('onboarding_completed', 'true');
    navigate('/role-selection');
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-dark">
      {/* Skip button */}
      <div className="flex justify-end p-4">
        <button
          onClick={handleSkip}
          className="text-gold text-sm font-medium"
        >
          Skip
        </button>
      </div>

      {/* Slides */}
      <div className="flex-1 flex flex-col items-center justify-center px-8 text-center pt-8">
        <div className="max-w-md w-full">
          <div className="mb-10 flex justify-center">
            <img
              src={slides[currentSlide].image}
              alt={slides[currentSlide].title}
              className="w-72 h-72 md:w-80 md:h-80 object-cover rounded-[3rem] shadow-2xl border border-gray-800"
            />
          </div>

          <div className="space-y-4">
            <h1 className="text-3xl font-bold text-white">
              {slides[currentSlide].title}
            </h1>
            <h2 className="text-xl font-medium text-gold/90">
              {slides[currentSlide].subtitle}
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed max-w-sm mx-auto">
              {slides[currentSlide].description}
            </p>
          </div>
        </div>

        {/* Progress indicators wrapper */}
        <div className="mt-12 flex space-x-3">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`h-1.5 transition-all duration-300 rounded-full ${index === currentSlide ? 'w-8 bg-gold' : 'w-2 bg-gray-800'
                }`}
            />
          ))}
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-between items-center p-6">
        <button
          onClick={handlePrev}
          disabled={currentSlide === 0}
          className={`px-6 py-3 rounded-full font-medium ${currentSlide === 0
            ? 'bg-gray-800 text-gray-600 cursor-not-allowed'
            : 'bg-gold text-dark hover:bg-opacity-90'
            }`}
        >
          Previous
        </button>

        <button
          onClick={handleNext}
          className="px-8 py-3 bg-gold text-dark rounded-full font-medium hover:bg-opacity-90 transition-colors"
        >
          {currentSlide === slides.length - 1 ? 'Accept & Get Started' : 'Next'}
        </button>
      </div>

      {/* Consent Disclaimer */}
      {currentSlide === slides.length - 1 && (
        <p className="text-center text-[10px] text-gray-600 px-6 pb-2">
          By clicking "Accept & Get Started", you acknowledge that you have read and agreed to our 
          <button onClick={() => navigate('/privacy-policy')} className="text-gold mx-1">Privacy Policy</button> 
          and 
          <button onClick={() => navigate('/terms-and-conditions')} className="text-gold mx-1">Terms & Conditions</button>.
        </p>
      )}
      {/* Legal Links Footer */}
      <div className="flex justify-center space-x-4 pb-6 text-xs text-gray-500">
        <button onClick={() => navigate('/privacy-policy')} className="hover:text-gold transition-colors">
          Privacy Policy
        </button>
        <span>•</span>
        <button onClick={() => navigate('/terms-and-conditions')} className="hover:text-gold transition-colors">
          Terms & Conditions
        </button>
      </div>
    </div>
  );
};

export default Onboarding;